<p-sidebar
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  position="right"
  [style]="{ width: '720px' }"
  [modal]="false"
  [showCloseIcon]="true"
  [blockScroll]="false"
  [closeOnEscape]="true"
  [appendTo]="'body'"
>
  <ng-template pTemplate="header">
    <afoone-wxrl-form-header
      [title]="drawerTitle"
      [activeTab]="'Acciones'"
    >
    </afoone-wxrl-form-header>
  </ng-template>

  <div class="drawer-content">
    <!-- Sección de Cabecera de Acción -->
    <!-- Mostrar si actionHeader existe o si estamos creando nueva acción -->
    <div class="action-header-section" *ngIf="actionHeader || !isEditMode">
      <h4>{{ "WXRL.ACTION.HEADER_TITLE" | translate }}</h4>

      <!-- Cargar acción reutilizable desde BD -->
      <div class="header-form-grid">
        <label class="header-label">{{ "WXRL.ACTION.LOAD_EXISTING_LABEL" | translate }}</label>
        <div class="header-field header-load-existing-row">
          <p-dropdown
            [options]="existingRuleActionOptions"
            optionLabel="label"
            optionValue="value"
            [ngModel]="selectedExistingRuleActionNr"
            (ngModelChange)="selectedExistingRuleActionNr = $event"
            [showClear]="true"
            [filter]="true"
            [virtualScroll]="true"
            [virtualScrollItemSize]="38"
            scrollHeight="200px"
            [appendTo]="'self'"
            [panelStyleClass]="'wxrl-existing-action-panel'"
            styleClass="load-existing-dropdown"
            [placeholder]="'WXRL.ACTION.LOAD_EXISTING_PLACEHOLDER' | translate"
          ></p-dropdown>
          <p-button
            class="load-existing-button"
            [label]="'WXRL.ACTION.LOAD_EXISTING_BUTTON' | translate"
            icon="pi pi-download"
            severity="secondary"
            (click)="onRequestLoadExistingAction()"
            [disabled]="!selectedExistingRuleActionNr"
          ></p-button>
        </div>
      </div>

      <!-- ID a la izquierda y Autor a la derecha -->
      <div class="header-id-author-row">
        <div class="header-id-container"></div>
      </div>

      <div [formGroup]="actionHeaderForm" class="header-form-grid">
        <label for="headerRuleActionNr" class="header-label">Nº Acción *</label>
        <div class="header-author-container">
          <input
            id="headerRuleActionNr"
            type="number"
            pInputText
            formControlName="ruleActionNr"
            class="header-id-input"
          />
          <small
            class="p-error"
            *ngIf="
              actionHeaderForm.get('ruleActionNr')?.invalid &&
              actionHeaderForm.get('ruleActionNr')?.touched
            "
          >
            El Nº Acción es obligatorio para crear pasos
          </small>
          <afoone-wxrl-authors
            [createdBy]="actionHeader?.author"
            [createdWhen]="actionHeader?.createdWhen"
          ></afoone-wxrl-authors>
        </div>
        <label for="headerRuleActionDesc" class="header-label"
          >Descripción</label
        >

        <div class="header-field">
          <input
            id="headerRuleActionDesc"
            type="text"
            pInputText
            formControlName="ruleActionDesc"
            class="header-input"
            [maxlength]="100"
          />
          <small
            class="p-error"
            *ngIf="
              actionHeaderForm.get('ruleActionDesc')?.hasError('maxlength') &&
              actionHeaderForm.get('ruleActionDesc')?.touched
            "
          >
            {{ "WXRL.ACTION.DESCRIPTION_MAXLENGTH_ERROR" | translate }}
          </small>
        </div>

        <label for="headerInfo" class="header-label">{{
          "WXRL.ACTION.ADDITIONAL_INFO" | translate
        }}</label>
        <div class="header-field">
          <textarea
            id="headerInfo"
            pInputTextarea
            formControlName="info"
            rows="2"
            class="header-input"
            [maxlength]="500"
          ></textarea>
          <small
            class="p-error"
            *ngIf="
              actionHeaderForm.get('info')?.hasError('maxlength') &&
              actionHeaderForm.get('info')?.touched
            "
          >
            {{ "WXRL.ACTION.INFO_MAXLENGTH_ERROR" | translate }}
          </small>
        </div>

        <!-- Reglas relacionadas -->
        <div class="header-label">{{ "WXRL.ACTION.RELATED_RULES" | translate }}</div>
        <div class="related-rules-container">
          <div *ngIf="loadingRelatedRules" class="loading-message">
            Cargando...
          </div>
          <div *ngIf="!loadingRelatedRules && relatedRules.length === 0" class="no-rules-message">
            {{ "WXRL.ACTION.NO_RELATED_RULES" | translate }}
          </div>
          <p-table
            *ngIf="!loadingRelatedRules && relatedRules.length > 0"
            [value]="relatedRules"
            [paginator]="false"
            [rows]="3"
            styleClass="p-datatable-sm related-rules-table"
            [scrollable]="true"
            scrollHeight="132px"
          >
            <ng-template pTemplate="header">
              <tr>
                <th scope="col">{{ "WXRL.RULE.ID_REGLA" | translate }}</th>
                <th scope="col">{{ "WXRL.RULE.DESCRIPCION" | translate }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rule>
              <tr>
                <td>{{ rule.ruleNr }}</td>
                <td>{{ rule.descripcion }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>

    <!-- Sección de Cuerpo de Acción -->
    <!-- Solo mostrar si la cabecera tiene un ruleActionNr válido (incluye 0) -->
    <div class="action-body-section" *ngIf="actionHeaderForm.get('ruleActionNr')?.value != null && actionHeaderForm.get('ruleActionNr')?.value !== ''">
      <h4>{{ "WXRL.ACTION.BODY_TITLE" | translate }}</h4>
      <div [formGroup]="actionForm" class="body-form-grid">
        <!-- Fila con No de paso y Estado -->
        <label for="posA" class="body-label">{{ "WXRL.ACTION.STEP_NUMBER" | translate }}</label>
        <div class="body-field-row">
          <span class="body-step-number">{{ actionForm.get('posA')?.value }}</span>
          <input type="hidden" formControlName="posA" />
          <label for="ruleState" class="body-label-inline">Estado *</label>
          <div class="body-field">
      <p-dropdown
        id="ruleState"
        formControlName="ruleState"
        [options]="actionStates"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione un estado"
        [showClear]="true"
        scrollHeight="280px"
        styleClass="w-full"
        [appendTo]="'self'"
        [panelStyleClass]="'p-dropdown-panel-state-width'"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          actionForm.get('ruleState')?.invalid &&
          actionForm.get('ruleState')?.touched
        "
      >
        El estado es obligatorio
      </small>
    </div>
    </div>

        <label for="actionKrz" class="body-label">Acción *</label>
        <div class="body-field action-field-container">
          <div class="action-dropdown-wrapper">
            <p-dropdown
              id="actionKrz"
              formControlName="actionKrz"
              [options]="actionCatalogOptions"
              optionLabel="labelAction"
              optionValue="actionKrz"
              placeholder="Seleccione una acción"
              [showClear]="true"
              (onChange)="onActionChange($event.value)"
              [filter]="true"
              scrollHeight="280px"
              styleClass="action-dropdown action-dropdown-clamped"
              [appendTo]="'self'"
              [attr.title]="selectedActionCatalogLabel || null"
            >

            <ng-template let-item pTemplate="item">
              <div class="flex align-items-center gap-2">

                  <div style="max-width: 500px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ item.labelAction }} </div>
              </div>
          </ng-template></p-dropdown>
            <div class="action-info-container">
              <p-button
                icon="pi pi-info-circle"
                [rounded]="true"
                [text]="true"
                (click)="onInfoClick()"
                [disabled]="!actionForm.get('actionKrz')?.value || !actionInfo"
                pTooltip="Información de la acción"
                tooltipPosition="left"
                styleClass="action-info-button"
              ></p-button>
              <div
                *ngIf="showActionInfo && actionInfo"
                class="action-info-message"
              >
                <div class="action-info-content">
                  <span>{{ actionInfo }}</span>
                  <button
                    type="button"
                    class="action-info-close"
                    (click)="closeActionInfo()"
                    aria-label="Cerrar"
                  >
                    <i class="pi pi-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <small
            class="p-error"
            *ngIf="
              actionForm.get('actionKrz')?.invalid &&
              actionForm.get('actionKrz')?.touched
            "
          >
            La acción es obligatoria
          </small>
        </div>

        <div
          *ngIf="showActionTargetBlock"
          class="action-target-block body-target-span"
        >
          <p class="action-target-block-title">Objetivo de la acción *</p>
          <p class="action-target-block-hint">
            Seleccione una opción: prueba, heredar o perfil
          </p>
          <div class="action-target-block-grid">
            <label for="methNr" class="body-label">Prueba</label>
            <div class="body-field">
              <p-dropdown
                id="methNr"
                formControlName="methNr"
                [options]="actionTestOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Seleccione una prueba"
                [showClear]="true"
                [filter]="true"
                [virtualScroll]="true"
                [virtualScrollItemSize]="38"
                scrollHeight="280px"
                styleClass="w-full"
                [appendTo]="'self'"
                [panelStyleClass]="'p-dropdown-panel-high-zindex p-dropdown-panel-fixed-width'"
                [disabled]="actionForm.get('heredar')?.value || actionTestOptions.length === 0"
                (onChange)="onMethNrChange()"
                (onShow)="onMethNrShow()"
                (onHide)="onMethNrHide()"
                (onClick)="onMethNrClick()"
              ></p-dropdown>
            </div>

            <span class="body-label"></span>
            <div class="body-field">
              <p-checkbox
                formControlName="heredar"
                inputId="heredar"
                [binary]="true"
                (onChange)="onHeredarChange($event.checked)"
              ></p-checkbox>
              <label for="heredar" class="ml-2">Heredar</label>
              <small class="block mt-1 text-gray-500"
                >Heredar la prueba del disparador dinámicamente</small
              >
            </div>

            <label for="grupNr" class="body-label">Perfil</label>
            <div class="body-field">
              <p-dropdown
                id="grupNr"
                formControlName="grupNr"
                [options]="actionProfileOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Seleccione un perfil"
                [showClear]="true"
                [filter]="true"
                scrollHeight="280px"
                styleClass="w-full"
                [appendTo]="'self'"
                (onChange)="onGrupNrChange()"
              ></p-dropdown>
            </div>
          </div>
          <small class="p-error block mt-1" *ngIf="actionTargetBlockError">
            {{ actionTargetBlockError }}
          </small>
        </div>

        <ng-container *ngIf="!showActionTargetBlock">
        <label for="methNr" class="body-label" *ngIf="showMethNr"
          >Prueba
          <span *ngIf="!actionForm.get('heredar')?.value">*</span></label
        >
        <div class="body-field" *ngIf="showMethNr">
      <p-dropdown
        id="methNr"
        formControlName="methNr"
        [options]="actionTestOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione una prueba"
        [showClear]="true"
        [filter]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        scrollHeight="280px"
        styleClass="w-full"
        [appendTo]="'self'"
        [panelStyleClass]="'p-dropdown-panel-high-zindex p-dropdown-panel-fixed-width'"
        [disabled]="actionTestOptions.length === 0"
        (onShow)="onMethNrShow()"
        (onHide)="onMethNrHide()"
        (onClick)="onMethNrClick()"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          actionForm.get('methNr')?.invalid &&
          actionForm.get('methNr')?.touched &&
          !actionForm.get('heredar')?.value
        "
      >
        La prueba es obligatoria
      </small>
    </div>

        <span class="body-label" *ngIf="showMethNr"></span>
        <div class="body-field" *ngIf="showMethNr">
      <p-checkbox
        formControlName="heredar"
        inputId="heredar"
        [binary]="true"
            (onChange)="onHeredarChange($event.checked)"
      ></p-checkbox>
      <label for="heredar" class="ml-2">Heredar</label>
          <small class="block mt-1 text-gray-500"
            >Heredar la prueba del disparador dinámicamente</small
          >
    </div>

        <label for="grupNr" class="body-label" *ngIf="showGrupNr"
          >Perfil *</label
        >
        <div class="body-field" *ngIf="showGrupNr">
      <p-dropdown
        id="grupNr"
        formControlName="grupNr"
        [options]="actionProfileOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione un perfil"
        [showClear]="true"
        [filter]="true"
        scrollHeight="280px"
        styleClass="w-full"
        [appendTo]="'self'"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          actionForm.get('grupNr')?.invalid &&
          actionForm.get('grupNr')?.touched
        "
      >
        El perfil es obligatorio
      </small>
    </div>
        </ng-container>

        <label for="textNr" class="body-label" *ngIf="showTextNr"
          >Texto *</label
        >
        <div class="body-field" *ngIf="showTextNr">
      <p-dropdown
        id="textNr"
        formControlName="textNr"
        [options]="actionTextOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione un texto"
        [showClear]="true"
        [filter]="true"
        scrollHeight="280px"
        styleClass="w-full"
        [appendTo]="'self'"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          actionForm.get('textNr')?.invalid &&
          actionForm.get('textNr')?.touched
        "
      >
        El texto es obligatorio
      </small>
    </div>

        <label for="actionValue" class="body-label" *ngIf="showActionValue"
          >Texto libre</label
        >
        <div class="body-field" *ngIf="showActionValue">
      <textarea
        id="actionValue"
        pInputTextarea
        formControlName="actionValue"
        rows="3"
            [maxlength]="100"
        class="w-full"
      ></textarea>
          <small class="p-text-secondary">
            {{ actionForm.get('actionValue')?.value?.length || 0 }} / 100
          </small>
          <small
            class="p-error"
            *ngIf="
              actionForm.get('actionValue')?.hasError('maxlength') &&
              actionForm.get('actionValue')?.touched
            "
          >
            El texto libre no puede exceder 100 caracteres
          </small>
    </div>

        <label for="additional1" class="body-label" *ngIf="showAdditional1"
          >{{ labelAdditional1 }} *</label
        >
        <div class="body-field" *ngIf="showAdditional1">
      <!-- Dropdown si add1Table = 1 -->
      <p-dropdown
        *ngIf="additional1IsDropdown"
        id="additional1"
        formControlName="additional1"
        [options]="actionAdditional1Options"
        optionLabel="label"
        optionValue="value"
        [appendTo]="'self'"
        placeholder="Seleccione..."
        [showClear]="true"
        [filter]="true"
        scrollHeight="280px"
        styleClass="w-full"
      ></p-dropdown>
      <!-- Textbox si add1Table = 0 -->
      <textarea
        *ngIf="!additional1IsDropdown"
            id="additional1-textbox"
        pInputTextarea
        formControlName="additional1"
        rows="3"
            [maxlength]="2048"
        class="w-full"
      ></textarea>
          <small
            class="p-text-secondary"
            *ngIf="!additional1IsDropdown"
          >
            {{ actionForm.get('additional1')?.value?.length || 0 }} / 2048
          </small>
      <small
        class="p-error"
        *ngIf="
              actionForm.get('additional1')?.hasError('required') &&
          actionForm.get('additional1')?.touched
        "
      >
        Este campo es obligatorio
      </small>
          <small
            class="p-error"
            *ngIf="
              actionForm.get('additional1')?.hasError('maxlength') &&
              actionForm.get('additional1')?.touched
            "
          >
            El campo no puede exceder 2048 caracteres
      </small>
    </div>

        <label for="additional2" class="body-label" *ngIf="showAdditional2"
          >{{ labelAdditional2 }} *</label
        >
        <div class="body-field" *ngIf="showAdditional2">
      <!-- Dropdown si add2Table = 1 -->
      <p-dropdown
        *ngIf="additional2IsDropdown"
            id="additional2-dropdown"
        formControlName="additional2"
        [options]="actionAdditional2Options"
        optionLabel="label"
        optionValue="value"
        [appendTo]="'self'"
        placeholder="Seleccione..."
        [showClear]="true"
        [filter]="true"
        scrollHeight="280px"
        styleClass="w-full"
      ></p-dropdown>
      <!-- Textbox si add2Table = 0 -->
      <textarea
        *ngIf="!additional2IsDropdown"
        id="additional2"
        pInputTextarea
        formControlName="additional2"
        rows="3"
            [maxlength]="2048"
        class="w-full"
      ></textarea>
          <small
            class="p-text-secondary"
            *ngIf="!additional2IsDropdown"
          >
            {{ actionForm.get('additional2')?.value?.length || 0 }} / 2048
          </small>
      <small
        class="p-error"
        *ngIf="
              actionForm.get('additional2')?.hasError('required') &&
          actionForm.get('additional2')?.touched
        "
      >
        Este campo es obligatorio
      </small>
          <small
            class="p-error"
            *ngIf="
              actionForm.get('additional2')?.hasError('maxlength') &&
              actionForm.get('additional2')?.touched
            "
          >
            El campo no puede exceder 2048 caracteres
      </small>
    </div>

        <label for="actionPersonnel" class="body-label"
          >Acción realizada por</label
        >
        <div class="body-field">
      <p-dropdown
        id="actionPersonnel"
        formControlName="actionPersonnel"
        [options]="actionPersonnelOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione personal"
        [showClear]="true"
        [filter]="true"
        scrollHeight="280px"
        styleClass="w-full"
        [appendTo]="'self'"
      ></p-dropdown>
    </div>

        <label for="isolation" class="body-label" *ngIf="showIsolation"
          >Aislamiento</label
        >
        <div class="body-field" *ngIf="showIsolation">
      <p-dropdown
        id="isolation"
        formControlName="isolation"
        [options]="actionIsolationOptions"
        optionLabel="schluessel"
        optionValue="schl"
        scrollHeight="280px"
        [appendTo]="'self'"
        placeholder="Seleccione aislamiento"
        [showClear]="true"
        styleClass="w-full"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          actionForm.get('isolation')?.invalid &&
          actionForm.get('isolation')?.touched
        "
      >
        El aislamiento es obligatorio
      </small>
    </div>

        <label for="kommentar" class="body-label">Comentario</label>
        <div class="body-field">
      <textarea
        id="kommentar"
        pInputTextarea
        formControlName="kommentar"
        rows="3"
            [maxlength]="255"
        class="w-full"
      ></textarea>
          <small class="p-text-secondary">
            {{ actionForm.get('kommentar')?.value?.length || 0 }} / 255
          </small>
          <small
            class="p-error"
            *ngIf="
              actionForm.get('kommentar')?.hasError('maxlength') &&
              actionForm.get('kommentar')?.touched
            "
          >
            El comentario no puede exceder 255 caracteres
          </small>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="drawer-footer">
      <p-button
        label="Cancelar"
        icon="pi pi-times"
        (click)="onCancel()"
        severity="secondary"
        [text]="true"
      ></p-button>
      <p-button
        [label]="isEditMode ? 'Actualizar' : 'Guardar'"
        icon="pi pi-check"
        (click)="onSave()"
        [disabled]="!canSave"
      ></p-button>
    </div>
  </ng-template>
</p-sidebar>
